"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _auth = require("@modules/auth");

var _updateItemList = _interopRequireDefault(require("./utils/updateItemList"));

var _buildStateFromList = _interopRequireDefault(require("./utils/buildStateFromList"));

var _state = _interopRequireDefault(require("./state"));

var _actions = require("./actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _state.default;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.FETCH_CART_SUCCESS:
      return _objectSpread({}, state, {
        delivery: action.cart.delivery,
        id: action.cart.id,
        itemList: action.cart.itemList,
        numItems: action.cart.numItems,
        order: action.cart.order,
        postalcode: action.cart.postalcode,
        products: action.cart.products,
        total: action.cart.total
      });

    case _actions.ADD_TO_CART_SUCCESS:
      {
        var list = (0, _updateItemList.default)(state.itemList, action.productID, action.cart.itemList[action.productID]);
        return (0, _buildStateFromList.default)(state, action, list);
      }

    case _auth.authActions.PURGE_ALL:
      return _state.default;

    default:
      return state;
  }
};

exports.default = _default;